import { Loader2 } from "lucide-react";
import { cn } from "~/utils/cn";

interface Props {
	className?: string;
}

const PageLoader = ({ className }: Props) => {
	return (
		<div className={cn("grid h-screen place-items-center", className)}>
			<Loader2 className="h-12 w-12 animate-spin" />
		</div>
	);
};

export { PageLoader };
